export default __webpack_public_path__ + "static/media/badge-check.cf67a4ae.svg";